var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-4 award-item"},[(_vm.award.award)?_c(_setup.HighlightableField,{attrs:{"enabled":_vm.tokensEnabled,"project":_vm.project,"candidate":_vm.candidate,"token-text":_vm.award.award,"token-type":"plain","additional-token-types":['plain'],"similarity-tokens":[]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }